import { useContext } from "react";
import { Coordinate, SpotType } from "~/generated/graphql.types";
import { EditModeContext, ViewMode } from "../..";
import { SpotForPreviewSidebarFragment } from "../../index.generated";

export type SpotForSidebar = {
  coordinate: Coordinate;
  courseId: string;
  description: string | null | undefined;
  id: string;
  name: string | null | undefined;
  note: string | null | undefined;
  order: number;
  parentSpotId: string | null | undefined;
  spotOrderLabel: string;
  spotType: SpotType;
  narrationText: string | null | undefined;
  isChild: boolean;
  isRoutingGuide: boolean;
  hasCafe: boolean;
  hasRestaurant: boolean;
  hasRestroom: boolean;
  hasFreeParking: boolean;
  hasPaidParking: boolean;
  hasLeftDotLine: boolean;
  hasLeftMargin: boolean;
  hasMusic: boolean;
};

export const convertParamsForSidebar = ({
  start,
  dest,
  waypoints,
}: {
  start: SpotForPreviewSidebarFragment | undefined;
  dest: SpotForPreviewSidebarFragment | undefined;
  waypoints: SpotForPreviewSidebarFragment[];
}) => {
  const { viewMode } = useContext(EditModeContext);
  const convertStart = start
    ? convertOneSpotToSpotForSidebar({
        spot: start,
        spotOrderLabel: "S",
      })
    : undefined;
  const convertDest = dest
    ? convertOneSpotToSpotForSidebar({
        spot: dest,
        spotOrderLabel: "G",
      })
    : undefined;
  const convertWaypoints = waypoints.map((spot, index) => {
    return convertOneSpotToSpotForSidebar({
      spot,
      spotOrderLabel: waypoints
        .slice(0, index + 1)
        .filter((p) => p?.spotType === spot.spotType)
        .length.toString(),
    });
  });
  return {
    startSidebar: convertStart,
    destSidebar: convertDest,
    waypointsSidebar: convertWaypoints,
  };
};

const convertOneSpotToSpotForSidebar = ({
  spot,
  spotOrderLabel,
}: {
  spot: SpotForPreviewSidebarFragment;
  spotOrderLabel: string;
}) => {
  const isChild = spot.parentSpotId !== null;
  const isRoutingGuide = spot.spotType == SpotType.RoutingGuide;

  const hasLeftDotLine = isRoutingGuide;
  const hasLeftMargin = isChild;
  const spotForSidebar: SpotForSidebar = {
    coordinate: spot.coordinate,
    courseId: spot.courseId,
    description: spot.description,
    id: spot.id,
    name: spot.name,
    note: spot.note,
    order: spot.order,
    parentSpotId: spot.parentSpotId,
    spotOrderLabel,
    spotType: spot.spotType,
    narrationText: spot.narrationText,
    isChild,
    isRoutingGuide,
    hasCafe: spot.hasCafe,
    hasRestaurant: spot.hasRestaurant,
    hasRestroom: spot.hasRestroom,
    hasFreeParking: spot.hasFreeParking,
    hasPaidParking: spot.hasPaidParking,
    hasLeftDotLine,
    hasLeftMargin,
    hasMusic: spot.hasMusic,
  };

  return spotForSidebar;
};
